import { render, staticRenderFns } from "./ManageFinancialNote.vue?vue&type=template&id=08871d9b&scoped=true&"
import script from "./ManageFinancialNote.vue?vue&type=script&lang=js&"
export * from "./ManageFinancialNote.vue?vue&type=script&lang=js&"
import style0 from "./ManageFinancialNote.vue?vue&type=style&index=0&id=08871d9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08871d9b",
  null
  
)

export default component.exports